export enum NavItemBadge {
  ADVISOR_PRO_BADGE = 'advisor-pro-badge'
}
